import React, { FC } from 'react'
import {useIntl} from 'react-intl';
import BaseKpi from './BaseKpi'
import {OrderKpiModel} from '../../core/_models';

interface Props {
  data: OrderKpiModel;
  isLoading: boolean;
}

export const OrderKpi: FC<Props> = ({ data, isLoading }) => {
  const intl = useIntl();

  const format = (value: number) => intl.formatNumber(value)
  const moneyFormat = (value: number) =>
    intl.formatNumber(value, { style: 'currency', currency: 'EUR' });
  const percFormat = (value: number) => {
    const _ = intl.formatNumber(value, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })

    return `${_}%`
  }

  const rows = [{
    label: 'Sales',
    curr: data.nb.curr,
    prev: data.nb.prev,
    icon: 'handcart',
    format
  }, {
    label: 'COGS',
    curr: data.cogs.curr,
    prev: data.cogs.prev,
    icon: 'euro',
    format: moneyFormat
  }, {
    label: 'Thumbs',
    curr: data.thumbs.up.curr + data.thumbs.down.curr,
    prev: data.thumbs.up.prev + data.thumbs.down.prev,
    icon: 'like',
    format
  }, {
    label: 'Earnings',
    curr: data.earnings.curr,
    prev: data.earnings.prev,
    icon: 'chart-pie-3',
    format: moneyFormat
  }, {
    label: 'Margin',
    curr: data.earnings.curr / (data.cogs.curr || 1) * 100,
    prev: data.earnings.prev / (data.cogs.prev || 1) * 100,
    icon: 'percentage',
    format: percFormat
  }]

  return (
    <BaseKpi
      color="primary"
      title="Sales summary"
      label="COGS"
      value={moneyFormat(data.cogs.curr)}
      isLoading={isLoading}
      rows={rows}
    />
  )
}
